import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CMS_THEME } from '../../common/enums';
import { CmsButton } from '../button/CmsButton';
import RichText from '../rich_text/RichText';

export interface Props {
  embedUrl: string;
  transcript: string;
  videoTitle: string;
  videoType: string;
  cmsTheme?: CMS_THEME;
}

const VideoEmbed = function ({
  embedUrl,
  transcript,
  videoType,
  videoTitle,
  cmsTheme = CMS_THEME.LIGHT,
}: Props): React.ReactElement | null {
  const [activeTranscript, setActiveTranscript] = useState(false);
  const { t } = useTranslation();
  const url = new URL(embedUrl);
  const urlParams = new URLSearchParams(url.search);
  const embedID = urlParams.get('v');

  const toggleTranscript = () => {
    sendIt({
      event: 'module_interaction',
      eventParams: {
        component_id: videoTitle,
        component_type: videoType,
        content_name: `${activeTranscript ? 'close' : 'open'} video transcript`,
      },
    });
    setActiveTranscript(!activeTranscript);
  };

  if (!embedID) {
    // eslint-disable-next-line no-console
    console.warn('Invalid remote video url provided.');
    return null;
  }

  return (
    <>
      <div className="pds-relative pds-h-0 pds-overflow-hidden pds-pb-[56.25%]">
        <iframe
          className="pds-absolute pds-left-0 pds-top-0 pds-h-full pds-w-full"
          width="920"
          height="510"
          src={`https://www.youtube-nocookie.com/embed/${embedID}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={embedID}
          style={{ borderRadius: '1rem' }}
        />
      </div>
      <div className="pds-text-center" id="transcript-bar">
        <CmsButton
          cmsTheme={cmsTheme}
          className="pds-inline pds-p-0 pds-capitalize"
          onClick={toggleTranscript}
          buttonStyle="text"
        >
          {t('View video transcript')}
        </CmsButton>
      </div>
      <Modal
        show={activeTranscript}
        size="lg"
        fullscreen="sm-down"
        scrollable
        onHide={toggleTranscript}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Video Transcript')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RichText className="pds-text-body-md" body={transcript} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VideoEmbed;
